import {toUTCString} from '../../../utils/date';
import {endpoints} from '../api';
import {useActions} from '../../../utils/globalStore';

import {actions as OrdersActions} from '../duck';

import type {OrderTaxInvoiceData} from '../../../entities';
import {useCallback} from 'react';
import {getTaxInvoiceOrdersByIdsService} from '../../tax-invoice/promises';
const baseURLDownload = endpoints.DOWNLOAD_CSV;

export const makeURL = (params: Object) => {
  const {filters, start, end} = params;
  let filterString = filters.join();

  const init_date = toUTCString(new Date(start));
  const end_date = toUTCString(new Date(end), true);

  return `${baseURLDownload}&states=${filterString}&init_date=${init_date}&end_date=${end_date}`;
};

export function useOrdersActions() {
  const updateOrderAction = useActions(OrdersActions.updateOrder);
  const updateOrderTaxInvoiceAction = useActions(
    OrdersActions.updateOrderTaxInvoice
  );

  const updateOrder = (orderId: order) => {
    updateOrderAction(orderId);
  };

  const updateOrderTaxInvoice = useCallback(
    (orderId: string, taxInvoiceData: OrderTaxInvoiceData[]) => {
      updateOrderTaxInvoiceAction(orderId, taxInvoiceData);
    },
    [updateOrderTaxInvoiceAction]
  );

  const refreshOrderTaxInvoice = useCallback(
    async (orderId: string) => {
      const taxInvoices = await getTaxInvoiceOrdersByIdsService([orderId]);
      const taxInvoice = taxInvoices && taxInvoices[0];
      if (!taxInvoice) return;
      updateOrderTaxInvoice(orderId, taxInvoice.orderTaxInvoices);
    },
    [updateOrderTaxInvoice]
  );

  return {
    updateOrder,
    updateOrderTaxInvoice,
    refreshOrderTaxInvoice,
  };
}
